import React, { useState, useEffect } from "react";
import { formatNumber } from "../utils";
import { useContext } from "react";
import { PortionsContext } from "../context/PortionsContext";
import InputRange from "react-input-range";
import close from "../assets/images/interface/close.svg";
import Spinner from "./Spinner";

const Title = ({ showFilters }) => {
  if (showFilters) {
    return null;
  }

  return <span className="home-filters-header-title">Lista de loteamientos</span>
}

const ResultsBody = ({ developments, context }) => {
  return (
    <div className="home-filters-body noPadding">
      <div
        style={{ padding: "20px 25px", fontSize: "24px", fontWeight: "600" }}
      >
        Lista de loteamientos
        </div>
      {developments.length > 0 ? (
        developments.map((d) => (
          <div
            key={d.id}
            onClick={() => context.setCurrentLoteamiento(d)}
            className={`home-filters-result shadow2 ${
              context.selectedLoteamiento?.id === d.id
                ? "home-filters-result-selected"
                : ""
              }`}
          >
            <div className="home-filters-resultTitle">
              {d.properties.name}
            </div>
            <div className="home-filters-resultBody">
              <div>
                <div className="home-filters-resultSubtitle">
                  Departamento
                  </div>
                <div style={{ fontWeight: "600" }}>
                  {
                    d.properties.developments.features[0].properties.district
                      .department.name
                  }
                </div>
              </div>
              <div>
                <div className="home-filters-resultSubtitle">Ciudad</div>
                <div style={{ fontWeight: "600" }}>
                  {
                    d.properties.developments.features[0].properties.district
                      .name
                  }
                </div>
              </div>
              <div>
                <div className="home-filters-resultSubtitle">Lotes</div>
                <div style={{ fontWeight: "600" }}>{d.total_parcels}</div>
              </div>
            </div>
            <div>
              <button className="home-filters-button">
                {context.selectedLoteamiento?.id === d.id
                  ? "Seleccionado"
                  : "Ver en el mapa"}
              </button>
            </div>
          </div>
        ))
      ) : (
          <div style={{ padding: "0px 25px", fontSize: "20px", color: "#999" }}>
            No hay resultados...
          </div>
        )}
    </div>
  );
}

const FiltersBody = ({ setShowFilters, showFilters }) => {
  const context = useContext(PortionsContext);
  const [searchText, setSearchText] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(5000000);

  const selectDepartment = (event) => {
    const departmentId = event.target.value;
    setSelectedDepartment(departmentId);
  }

  const selectDistrict = (event) => {
    const districtId = event.target.value;
    setSelectedDistrict(districtId);
  }

  const clearFilters = () => {
    setSelectedPrice(50000000)
    setSelectedDistrict(null);
    setSelectedDepartment(null);
  }
  const applyFilters = () => {
    context.applyFilters({
      searchText,
      maxPrice: selectedPrice,
      districtId: selectedDistrict,
      departmentId: selectedDepartment,
    });
    setShowFilters(false);
  }

  return (
    <>
      <div className="home-filters-body" style={!showFilters ? { display: 'none' } : {}}>
        <input
          className="home-search-filters mobile-noDisplay shadow1"
          type="text"
          placeholder="BUSCAR"
          onChange={(event) => setSearchText(event.target.value)}
        ></input>
        <p className="home-input-description mobile-noDisplay darkgrayColor textCentered mb-4">
          Escribe el nombre de la ciudad o la fracción
        </p>
        <select
          className="home-filters-dropdown shadow2"
          onChange={(event) => {
            selectDepartment(event);
          }}
          selected={selectedDepartment}
        >
          <option value={null}>Departamento</option>
          {context.departments.map((department) => (
            <option value={department.id} key={department.id}>
              {department.name}
            </option>
          ))}
        </select>

        {selectedDepartment != null && (
          <select
            className="home-filters-dropdown shadow2"
            onChange={(event) => selectDistrict(event)}
            selected={selectedDistrict}
          >
            <option value={null}>Ciudad</option>
            {context.districts
              .filter((d) => +d.department.id === + selectedDepartment)
              .map((d) => (
                <option value={d.id} key={d.id}>
                  {d.name}
                </option>
              ))}
          </select>
        )}
        <div className="home-filters-title" style={{ marginTop: "16px" }} value={selectedPrice}>
          Monto máximo de cuota
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "0px 10px",
            boxSizing: "border-box",
          }}
        >
          <span>0 Gs.</span>
          <span>5.000.000 Gs.</span>
        </div>
        <InputRange
          maxValue={5000000}
          minValue={0}
          step={50000}
          value={selectedPrice}
          onChange={(event) => setSelectedPrice(event)}
          formatLabel={null}
        />
        <div
          style={{
            textAlign: "end",
            width: "100%",
            padding: "0px 10px",
            boxSizing: "border-box",
          }}
        >
          {formatNumber(selectedPrice)} Gs.
        </div>
      </div>
      <button
        onClick={() => clearFilters()}
        className={`home-filters-whiteButton shadow1`}
        style={!showFilters ? { display: 'none' } : {}}
      >
        Limpiar filtros
          </button>
      <button
        onClick={() => applyFilters()}
        className="home-filters-redButton shadow1"
        style={!showFilters ? { display: 'none' } : {}}
      >
        Aplicar Filtros
      </button>
    </>
  );
}

export default function Filters() {
  const context = useContext(PortionsContext);
  const [filterResults, setFilterResults] = useState([]);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    setFilterResults(context.developments);
  }, [context.developments]);

  if (context.searching) {
    return (
      <div className={"home-filters mobile-noDisplay"} >
        <div className="spinner-container" style={{
          height: `calc(100vh + var(--detailHeaders-height) - var(--header-height) - var(--detailHeaders-height)`,
        }}><Spinner /></div>
      </div>
    );
  }

  return (
    <div className={"home-filters mobile-noDisplay"} >
      <div className="home-filters-header desktop-noDisplay">
        <Title showFilters={showFilters} />
        <img
          className="home-filters-header-close"
          src={close}
          alt="X"
        ></img>
      </div>

      <FiltersBody setShowFilters={setShowFilters} showFilters={showFilters} />

      {
        !showFilters &&
        <>
          <ResultsBody developments={filterResults} context={context} />
          <button
            onClick={() => setShowFilters(true)}
            className="home-filters-whiteButton-fullwidth shadow1"
          >
            Volver a filtros
          </button>
        </>
      }
    </div>
  );
}
